import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { COMPANY, PAYMENT } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const initialState = {};

export const getClientCards = createAsyncThunk(
	'user/getClientCards',
	async ({ forceSync, isCvvRequire = false }, { getState, rejectWithValue }) => {
		const { user } = getState();
		if (user.clientCards && !forceSync) {
			return user.clientCards;
		}
		const axiosPrivate = useAxiosPrivate();
		try {
			const response = await axiosPrivate.post(PAYMENT.GET_CLIENT_CARDS_OF_COMPANY, {
				getCvvRequired: isCvvRequire
			});
			if (response.status === 200) {
				return response.data;
			}
		} catch (error) {
			AppLogger.error(error);
			throw rejectWithValue(error);
		}
	}
);

export const getPickupLocationCountries = createAsyncThunk(
	'user/getPickupLocationCountries',
	async (payload, { getState, rejectWithValue }) => {
		const { user } = getState();
		if (user.pickupLocationCountries && payload?.invalidate !== true) {
			return user.pickupLocationCountries;
		}
		const axiosPrivate = useAxiosPrivate();
		try {
			const response = await axiosPrivate.post(COMPANY.GET_PICKUP_LOCATION_COUNTRIES);
			if (response.status === 200) {
				return response.data;
			}
		} catch (error) {
			AppLogger.error(error);
			throw rejectWithValue(error);
		}
	}
);

const user = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setUserDetails: (state, { payload }) => ({
			...state,
			...payload,
			isSupportUser: payload?.roles?.some((role) => role.roleID === 91) ?? state.isSupportUser
		}),
		setUserGeneralSettings: (state, { payload }) => ({
			...state,
			generalSettings: {
				...state.generalSettings,
				...payload
			}
		}),
		setUserLocalization: (state, { payload }) => ({
			...state,
			localization: {
				...state.localization,
				...payload
			}
		}),
		setUserInitialized: (state, { payload }) => ({
			...state,
			initialized: payload
		})
	},
	extraReducers: (builder) => {
		builder.addCase(getClientCards.fulfilled, (state, { payload }) => ({ ...state, clientCards: payload }));
		builder.addCase(getPickupLocationCountries.fulfilled, (state, { payload }) => ({
			...state,
			pickupLocationCountries: payload
		}));
	}
});

export const { setUserDetails, setUserGeneralSettings, setUserInitialized, setUserLocalization } = user.actions;

export default user.reducer;
